export default __webpack_public_path__ + "static/media/836.333a31a0.png";